import { firebase } from '../config/configureFirebase';
import store from '../store/store';

const getMapapiURL = () => {
    return `https://imphalcab-69cbe.web.app/mapapi`;
};

const getMapboxToken = () => {
    const { config } = firebase;
    return (config.mapbox_access_token && config.mapbox_access_token.server) ? config.mapbox_access_token.server : 'pk.eyJ1IjoiaW1waGFsY2FicyIsImEiOiJjbW1sdm90c24wdmQzMnFyMGJ3YXhhMHEwIn0.qVO3CoXPqG0PqmK-2IUzVw';
};

export const fetchPlacesAutocomplete = (searchKeyword, sessionToken) => {
    return new Promise((resolve, reject) => {
        const settings = store.getState()?.settingsdata?.settings;
        const mapboxToken = getMapboxToken();
        let bboxParam = settings && settings.restrictCountry ? `&country=${settings.restrictCountry.toLowerCase()}` : '';
        let langParam = settings && settings.mapLanguage ? `&language=${settings.mapLanguage}` : '';
        const url = getMapapiURL();
        const body = {
            searchKeyword: searchKeyword,
            sessiontoken: sessionToken
        };

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        }).then(response => {
            return response.json();
        }).then(json => {
            if (json && json.searchResults) {
                resolve(json.searchResults);
            } else {
                reject("No results");
            }
        }).catch(error => {
            console.log(error);
            reject("fetchPlacesAutocomplete Call Error");
        });
    });
}

export const fetchCoordsfromPlace = (place_id) => {
    return new Promise((resolve, reject) => {
        const mapboxToken = getMapboxToken();
        const url = getMapapiURL();
        const body = {
            place_id: place_id,
            sessiontoken: '12345'
        };

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        }).then(response => {
            return response.json();
        }).then(json => {
            if (json && json.coords) {
                resolve(json.coords);
            } else {
                reject("No coords found");
            }
        }).catch(error => {
            console.log(error);
            reject("fetchCoordsfromPlace Call Error");
        });
    });
}

export const fetchAddressfromCoords = (latlng) => {
    return new Promise((resolve, reject) => {
        const mapboxToken = getMapboxToken();
        const [lat, lng] = latlng.split(',');
        const url = getMapapiURL();
        const body = {
            latlng: latlng
        };

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        }).then(async response => {
            console.log("fetchAddressfromCoords Status:", response.status);
            const json = await response.json();
            console.log("fetchAddressfromCoords Response:", json);
            if (json && json.address) {
                resolve(json.address);
            } else {
                reject("No address found");
            }
        }).catch(error => {
            console.log("fetchAddressfromCoords Error:", error);
            reject("fetchAddressfromCoords Call Error");
        });
    });
}

export const getDistanceMatrix = (startLoc, destLoc) => {
    return new Promise((resolve, reject) => {
        const mapboxToken = getMapboxToken();
        const [startLat, startLng] = startLoc.split(',');
        const destArray = destLoc.split('|').map(coord => {
            const [lat, lng] = coord.split(',');
            return `${lng},${lat}`;
        });
        let coordinates = `${startLng},${startLat};` + destArray.join(';');
        let destIndices = destArray.map((_, i) => i + 1).join(';');
        const url = getMapapiURL();
        const body = {
            start: startLoc,
            dest: destLoc,
            calltype: 'matrix'
        };

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        }).then(response => {
            return response.json();
        }).then(json => {
            if (Array.isArray(json)) {
                resolve(json);
            } else {
                reject("No matrix found");
            }
        }).catch(error => {
            console.log(error);
            reject("getDistanceMatrix Call Error");
        });
    });
}

export const getDirectionsApi = (startLoc, destLoc, waypoints) => {
    return new Promise((resolve, reject) => {
        const mapboxToken = getMapboxToken();
        const [startLat, startLng] = startLoc.split(',');
        const [destLat, destLng] = destLoc.split(',');
        let coordinates = `${startLng},${startLat}`;
        if (waypoints) {
            const wpArray = waypoints.split('|').map(wp => {
                const [lat, lng] = wp.split(',');
                return `${lng},${lat}`;
            });
            coordinates += ';' + wpArray.join(';');
        }
        coordinates += `;${destLng},${destLat}`;
        const url = getMapapiURL();
        const body = {
            start: startLoc,
            dest: destLoc,
            waypoints: waypoints,
            calltype: 'direction'
        };

        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        }).then(response => {
            return response.json();
        }).then(json => {
            if (json && !json.error) {
                resolve(json);
            } else {
                reject("No route found");
            }
        }).catch(error => {
            console.log(error);
            reject("getDirectionsApi Call Error");
        });
    });
}

